/*Plugin below should be moved into separate file*/
/*! Lazy Load 1.9.3 - MIT license - Copyright 2010-2013 Mika Tuupola */
!function(a,b,c,d){var e=a(b);a.fn.lazyload=function(f){function g(){var b=0;i.each(function(){var c=a(this);if(!j.skip_invisible||c.is(":visible"))if(a.abovethetop(this,j)||a.leftofbegin(this,j));else if(a.belowthefold(this,j)||a.rightoffold(this,j)){if(++b>j.failure_limit)return!1}else c.trigger("appear"),b=0})}var h,i=this,j={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!0,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};return f&&(d!==f.failurelimit&&(f.failure_limit=f.failurelimit,delete f.failurelimit),d!==f.effectspeed&&(f.effect_speed=f.effectspeed,delete f.effectspeed),a.extend(j,f)),h=j.container===d||j.container===b?e:a(j.container),0===j.event.indexOf("scroll")&&h.bind(j.event,function(){return g()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,(c.attr("src")===d||c.attr("src")===!1)&&c.is("img")&&c.attr("src",j.placeholder),c.one("appear",function(){if(!this.loaded){if(j.appear){var d=i.length;j.appear.call(b,d,j)}a("<img />").bind("load",function(){var d=c.attr("data-"+j.data_attribute);c.hide(),c.is("img")?c.attr("src",d):c.css("background-image","url('"+d+"')"),c[j.effect](j.effect_speed),b.loaded=!0;var e=a.grep(i,function(a){return!a.loaded});if(i=a(e),j.load){var f=i.length;j.load.call(b,f,j)}}).attr("src",c.attr("data-"+j.data_attribute))}}),0!==j.event.indexOf("scroll")&&c.bind(j.event,function(){b.loaded||c.trigger("appear")})}),e.bind("resize",function(){g()}),/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent&&b.originalEvent.persisted&&i.each(function(){a(this).trigger("appear")})}),a(c).ready(function(){g()}),this},a.belowthefold=function(c,f){var g;return g=f.container===d||f.container===b?(b.innerHeight?b.innerHeight:e.height())+e.scrollTop():a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return g=f.container===d||f.container===b?e.width()+e.scrollLeft():a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollTop():a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollLeft():a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!(a.rightoffold(b,c)||a.leftofbegin(b,c)||a.belowthefold(b,c)||a.abovethetop(b,c))},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})}(jQuery,window,document);


jQuery(function ($) {
    InitDatePicker();
  
  $( ".month-date"  ).click(function() {
  	$( ".datepicker"  ).show();
  });
  
});
var InitDatePicker = function(){
  var _FirstSelectableDate = new Date();
  
  //we need to set up the first selectable date before initializing the datepicker...
  var cstOffset = -6;
  var appointementOffsetInHour = 2;
  var timeZoneOffset = _FirstSelectableDate.getTimezoneOffset();
  var gmtDate = new Date();
  if(timeZoneOffset < 0 || timeZoneOffset > 0){
    gmtDate = gmtDate.addHours((timeZoneOffset / 60));
  }

  _FirstSelectableDate = gmtDate.addHours(cstOffset);
  var currentHour = _FirstSelectableDate.getHours() + (_FirstSelectableDate.getMinutes() / 60);
  
  var contactTimeElement = $('select[name="contact[time]"]');
  var maxAppointementTimeInHour = $('option:last', contactTimeElement).attr('data-hour');
  if(currentHour + appointementOffsetInHour >= maxAppointementTimeInHour){
    //max time has reached, appointement will be for tomorrow...
    _FirstSelectableDate.addDays(1);
  }else{
    var defaultSelected = false;
    $('select[name="contact[time]"] option').each(function(){
      var hour = parseFloat($(this).attr('data-hour'), 10);
      if((currentHour + appointementOffsetInHour) > hour){
        $(this).css('display','none');
        $(this).addClass('hidden-fortoday');
      }else{
        if(!defaultSelected){
          $(this).attr('selected', true);
          defaultSelected = true;
        }
      }

      //uniform js has to be updated..
      try{
        $.uniform.update('select[name="contact[time]"]');
      }catch(ex){};

    });
  }

  var PopulateTimeDropDown = function(isFutureDate){
      if(isFutureDate){
        $('option', contactTimeElement).css('display','block');
        $('option[data-hour="10"]', contactTimeElement).attr('selected', true);
      }else{
        $('option.hidden-fortoday', contactTimeElement).css('display','none');
        $('option:not(".hidden-fortoday")', contactTimeElement).first().attr('selected', true);
      }

      //uniform js has to be updated..
      try{
        $.uniform.update('select[name="contact[time]"]');
      }catch(ex){};
  };


  var EnablePreviousDateButton = function(enable){
    var previousDateButton = $('div.choose-option div.previous');
    enable ? previousDateButton.removeClass('disabled').addClass('enabled') : previousDateButton.removeClass('enabled').addClass('disabled');
  };

  $('.choose-option').on('click',function(e){
    var target = $(e.target);
    target.is('div.previous.enabled') || target.is('div.next') ? 
    ShiftDate(target) : 
    $('.choose-option').DatePickerShow();
  });

  var ShiftDate = function(target){
    var selectedDate = calendar.DatePickerGetDate();
    selectedDate.addDays(target.is('div.next') ? 1 : -1);
    var formattedDate = (selectedDate.getMonth()+1)+"/"+selectedDate.getDate()+"/"+selectedDate.getFullYear();
    calendar.DatePickerSetDate(formattedDate, true);
    OnDateChanged(formattedDate, selectedDate);
  };

  var OnDateChanged = function(formattedDate, dates){
    var month = dates.getMonth();
    var day = dates.getDate();
    $('#datepick').val(formattedDate);
    $('.choose-option').DatePickerHide();
    $('.month-date').html(months[month]+"<span>"+day+"</span>");
    EnablePreviousDateButton(dates.valueOf() > _FirstSelectableDate.valueOf());
    PopulateTimeDropDown(dates.valueOf() > _FirstSelectableDate.valueOf());
  };

  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var dd = _FirstSelectableDate.getDate();
  var mm = _FirstSelectableDate.getMonth()+1; //January is 0!
  var yyyy = _FirstSelectableDate.getFullYear();
  var selectedDate = mm+"/"+dd+"/"+yyyy;
  $('.month-date').html(months[mm-1]+"<span>"+dd+"</span>");
  $('#datepick').val(selectedDate);
  var calendar = $('.choose-option').DatePicker({
    flat: true,
    format: 'm/d/Y',
    date: selectedDate,
    current: selectedDate,
    starts: 1,
    position: 'bottom',
    onBeforeShow: function(){
      //$('.choose-option').DatePickerSetDate($('#datepick').val(), true);
    EnablePreviousDateButton(0);
    },
    onChange: function(formattedDate, dates){
      OnDateChanged(formattedDate, dates);
    },
    onRender: function(date) {
      var firstSelectableDate = _FirstSelectableDate;
      firstSelectableDate.setHours(0),
      firstSelectableDate.setMinutes(0),
      firstSelectableDate.setSeconds(0),
      firstSelectableDate.setMilliseconds(0);
      return {
        disabled: (date.valueOf() < firstSelectableDate.valueOf())
      }
    }
  });
};

//date class extension..
Date.prototype.addHours = function(hours){
  this.setHours(this.getHours()+hours);
  return this;
};
